
<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">入口設定 - {{portal.title}}</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <el-col :xs="12" :md="3">
                      <router-link to="../../portals" type="success">
                        <el-button type="warning" size="small">返回入口列表</el-button>
                      </router-link>
                    </el-col>
                  </div>
                  
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <h5>1. 基本設定</h5>
                  </div>
                  <div class="col-md-6">
                    <!-- <label>活動名稱</label>
                    <el-input
                      size="small"
                      v-model="portal.name"
                      placeholder="新戶首次線上消費100送折價券"
                    ></el-input> -->
                    <fg-input label="入口Key(小寫或底線)，出現於網址，全系統唯一"
                      required
                      placeholder="gofoodie"
                      v-model="portal.portalKey"
                      v-validate="modelValidations.name"
                      :error="getError('name')"
                      name="name">
                    </fg-input>
                    <fg-input label="入口標題，顯示在瀏覽器標題"
                      required
                      placeholder="GoFoodie 吃貨快點"
                      v-model="portal.title"
                      v-validate="modelValidations.name"
                      :error="getError('name')"
                      name="name">
                    </fg-input>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <div><label>頁面配置</label></div>
                        <el-select v-model="portal.tabSetting" filterable placeholder="請選擇">
                          <el-option
                            v-for="item in tabOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col-md-6">
                        <div><label>連結類型</label></div>
                        <el-select v-model="portal.linkType" filterable placeholder="請選擇">
                          <el-option
                            v-for="item in linkTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                      <fg-input label="LIFF or WEBSSO ID"
                        required
                        placeholder="theme_default"
                        v-model="portal.liffId"
                        v-validate="modelValidations.liffId"
                        :error="getError('name')"
                        name="name">
                      </fg-input>
                      </div>
                      <div class="col-md-6">
                      <fg-input label="GTM CODE"
                        required
                        placeholder="theme_default"
                        v-model="portal.gtmCode"
                        v-validate="modelValidations.gtmCode"
                        :error="getError('name')"
                        name="name">
                      </fg-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <fg-input label="色彩主題"
                          required
                          placeholder="theme_default"
                          v-model="portal.theme"
                          v-validate="modelValidations.name"
                          :error="getError('name')"
                          name="name">
                        </fg-input>
                      </div>
                      <div v-show="portal.linkType === 'WEB'" class="col-md-6">
                        <div><label>是否開啟入口登入</label></div>
                        <!-- 使用 :label 值為數字-->
                        <el-radio-group v-model="portal.enablePortalLogin">
                          <el-radio-button :label="0">關閉</el-radio-button>
                          <el-radio-button :label="1">開啟</el-radio-button>
                        </el-radio-group>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="text-center" v-if="mode === 'update'">
                      <div>
                        <el-button type="primary" size="mini" @click.native="saveInfo()">更新基本資訊</el-button>
                      </div>

                      <div v-if="updateInfo === 'updating'" style="margin: 10px 0 0 0;">
                        設定中
                        <i class="el-icon-loading"></i>
                      </div>
                      <div
                        v-if="updateInfo === 'success'"
                        style="color:#00BA00; margin: 10px 0 0 0;"
                      >
                        設定成功
                        <i class="now-ui-icons ui-1_check"></i>
                      </div>
                      <div v-if="updateInfo === 'error'" style="color:#BA0000; margin: 10px 0 0 0;">
                        設定失敗
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header">
                <h5 class="card-title">2. 圖片設定 </h5>
              </div>
              <div class="card-body">
               <div class="row">
                <div class="col-md-6">
                  <fg-input label="LOGO圖片"
                    required
                    placeholder="https://sample.com/image.jpg"
                    v-model="portal.logo"
                    v-validate="modelValidations.name"
                    :error="getError('name')"
                    name="name">
                  </fg-input>
                </div>
                <div class="col-md-6">
                  <img  v-if="portal.logo" :src="portal.logo" class="mt-4" height="60px" />
                </div>
               </div>
               <div class="row">
                <div class="col-md-6">
                  <fg-input label="favicon圖片"
                    required
                    placeholder="https://sample.com/image.png"
                    v-model="portal.favicon"
                    v-validate="modelValidations.name"
                    :error="getError('name')"
                    name="name">
                  </fg-input>
                </div>
                <div class="col-md-6">
                  <img v-if="portal.logo" :src="portal.favicon" class="mt-4" height="60px"  />
                </div>
               </div>
               <div class="row">
                <div class="col-md-6">
                  <fg-input label="商家預設圖"
                    required
                    placeholder="https://sample.com/image.jpg"
                    v-model="portal.defaultShops"
                    v-validate="modelValidations.name"
                    :error="getError('name')"
                    name="name">
                  </fg-input>
                </div>
                <div class="col-md-6">
                  <img v-if="portal.logo" :src="portal.defaultShops" class="mt-4" height="60px"  />
                </div>
               </div>
               <div class="row">
                <div class="col-md-12 mt-8">
                  <div class="text-center" v-if="mode === 'update'">
                    <div>
                      <el-button
                        type="primary"
                        size="mini"
                        @click.native="saveImages()"
                      >更新圖片設定</el-button>
                    </div>

                    <div v-if="updateImages === 'updating'" style="margin: 10px 0 0 0;">
                      設定中
                      <i class="el-icon-loading"></i>
                    </div>
                    <div
                      v-if="updateImages === 'success'"
                      style="color:#00BA00; margin: 10px 0 0 0;"
                    >
                      設定成功
                      <i class="now-ui-icons ui-1_check"></i>
                    </div>
                    <div
                      v-if="updateImages === 'error'"
                      style="color:#BA0000; margin: 10px 0 0 0;"
                    >
                      設定失敗
                      <i class="now-ui-icons ui-1_simple-remove"></i>
                    </div>
                  </div>
                </div>
               </div>
               
              </div>

              <div class="card-header" v-if="mode === 'update'">
                <h5 class="card-title">3. 橫幅圖片管理</h5>
              </div>
              <div class="card-body" v-if="mode === 'update'">
                <div class="row">
                  <div class="col-md-6">
                    <div v-for="(banner, index) of banners" :key=index>
                       <fg-input label="橫幅圖片網址"
                        required
                        placeholder="https://sample.com/image.jpg"
                        v-model="banners[index]"
                        :error="getError('name')"
                        name="name">
                      </fg-input>
                      <el-button type="danger" size="mini" @click.native="removeBanner(index)">刪除</el-button>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div><label>新增橫幅圖片</label></div>
                    <el-button type="success" size="mini" @click.native="addBanner()">新增</el-button>
                  </div>
                  <div class="col-md-12">
                    <div class="text-center" v-if="mode === 'update'">
                      <div>
                        <el-button type="primary" size="mini" @click.native="saveBanners()">更新橫幅圖片</el-button>
                      </div>

                      <div v-if="updateBanners === 'updating'" style="margin: 10px 0 0 0;">
                        設定中
                        <i class="el-icon-loading"></i>
                      </div>
                      <div
                        v-if="updateBanners === 'success'"
                        style="color:#00BA00; margin: 10px 0 0 0;"
                      >
                        設定成功
                        <i class="now-ui-icons ui-1_check"></i>
                      </div>
                      <div
                        v-if="updateBanners === 'error'"
                        style="color:#BA0000; margin: 10px 0 0 0;"
                      >
                        設定失敗
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                      </div>
                    </div>
                  </div>
                </div>
                
                
                
              </div>

              <div class="card-body" v-if="mode === 'new'">
                <div class="text-center">
                  <div v-if="createMessage === 'updating'" style="margin: 10px 0 0 0;">
                    建立中
                    <i class="el-icon-loading"></i>
                  </div>
                  <div
                    v-if="createMessage === 'success'"
                    style="color:#00BA00; margin: 10px 0 0 0;"
                  >
                    建立成功
                    <i class="now-ui-icons ui-1_check"></i>
                  </div>
                  <div
                    v-if="createMessage === 'error'"
                    style="color:#BA0000; margin: 10px 0 0 0;"
                  >
                
                  <p v-for="item in createErrorMessages"><i class="now-ui-icons ui-1_simple-remove"></i> {{ item }}</p>
                  </div>
                  <el-button type="primary" @click.native="createPortal()">建立入口</el-button>
                </div>
              </div>

              <!-- <div class="card-header">
                <h5 class="card-title">4. 新增參與店家</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <el-row :gutter="20">
                      <el-col :xs="24" :md="6">
                        <el-input
                          v-model="filters[0].value"
                          size="small"
                          placeholder="搜尋活動"
                          prefix-icon="el-icon-search"
                        ></el-input>
                      </el-col>
                      <el-col :xs="24" :md="6">
                        <router-link to="./send-coupons/add-shops" type="success">
                          <el-button type="primary" size="small" plain>新增參與店家</el-button>
                        </router-link>
                      </el-col>
                    </el-row>

                    <data-tables :data="data" :filters="filters" :action-col="actionCol">
                      <el-table-column
                        v-for="title in titles"
                        :prop="title.prop"
                        :label="title.label"
                        :key="title.prop"
                        sortable="custom"
                      ></el-table-column>
                    </data-tables>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { Checkbox, Radio } from "src/components/index";
import {
  TimeSelect,
  DatePicker,
  Tag,
  Input,
  Button,
  Select,
  Option
} from "element-ui";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    Checkbox,
    Radio
  },
  data() {
    return {
      modelValidations: {
        name: {
          required: true
        },
        // fullQuotaMessage: {
        //   required: true,
        //   // email: true
        // },
        // voucherMessage: {
        //   required: true,
        //   // min: 5
        // }
      },
      portal: {
        portalKey: '',
        title: '',
        theme: '',
        liffId: '',
        gtmCode: '',
        tabSetting: '',
        linkType: '',
        logo: '',
        favicon: '',
        defaultShops: '',
        liffApp: '',
        servicePage: '',
        notifyAppId: '',
        servicePage: '',
        enablePortalLogin: 0
      },
      linkTypeOptions: [
        {
          "label": "隨商店設定",
          "value": "SHOP_CONF"
        },
        {
          "label": "OA加好友連結",
          "value": "OA"
        },
        {
          "label": "WEB版",
          "value": "WEB"
        }
      ],
      tabOptions: [
        {
          "label": "外送、自取、訂單、設定",
          "value": "dtos"
        },
        {
          "label": "外送、訂單、設定",
          "value": "dos"
        },
        {
          "label": "自取、外送、訂單、設定",
          "value": "tdos"
        },
        {
          "label": "自取、訂單、設定",
          "value": "tos"
        },
        {
          "label": "外送、自取、設定",
          "value": "dts"
        },
        {
          "label": "外送、設定",
          "value": "ds"
        },
        {
          "label": "購物、訂單、設定",
          "value": "ros"
        },
        {
          "label": "購物、美食、訂單、設定",
          "value": "rfos"
        },
        {
          "label": "外送、自取、購物、訂單、設定",
          "value": "dtros"
        },
        {
          "label": "自取、外送、購物、訂單、設定",
          "value": "tdros"
        },
        {
          "label": "訂單、設定",
          "value": "os"
        }
      ],
      banners: [],
      mode: 'new',
      createMessage: null,
      createErrorMessages: [], 
      updateInfo: null,
      updateImages: null,
      updateBanners: null,
      startTime: "",
      endTime: ""
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    getPortalDetail() {
      let self = this;
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}`
        )
        .then(response => {
          console.log('the response ' + JSON.stringify(response.data));
          this.portal = response.data || {};
          if (response.data.banners)
            this.banners = response.data.banners;
          
          // this.formatCampaign();
          
          return response.data;
        })
        .catch(function(e) {
          console.log(e.stack);
        });
    },
    createPortal() {
      this.createMessage = 'updating';
      this.createErrorMessages = [];
      this.$validator.validateAll().then(isValid => {
        
        console.log('any error? ' + this.createErrorMessages.length);
        if (this.createErrorMessages.length > 0 || !isValid) {
          this.createMessage = "error";
          return;
        }

        const portal = Object.assign({}, this.portal);
        portal.enablePortalLogin = portal.linkType === 'WEB' ? portal.enablePortalLogin : 0;
        return axios
          .post(
            `${process.env.VUE_APP_APIHOST}/gaa/portals`,
            portal
          )
          .then(response => {
            this.createMessage = "success";

            
            this.$router.push(`../portals`);

            // console.log(response.data);
            return response.data;
          })
          .catch(e => {
            console.log(e.stack);
            this.createMessage = "error";
            this.createErrorMessages.push(e.message);
          });
      });      
    },
    saveInfo() {
      // console.log("the campaign group " + JSON.stringify(this.campaignGroup));
      this.updateInfo = "updating";

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}`,
          {
            title: this.portal.title,
            theme: this.portal.theme,
            liffId: this.portal.liffId,
            gtmCode: this.portal.gtmCode,
            tabSetting: this.portal.tabSetting,
            linkType: this.portal.linkType,
            enablePortalLogin: this.portal.linkType === 'WEB' ? this.portal.enablePortalLogin : 0
          }
        )
        .then(response => {
          this.updateInfo = "success";
          // this.portal = response.data || {};
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateInfo = "error";
        });
    },
    saveImages() {
      this.updateImages = "updating";
      
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}/images`,
          {
            logo: this.portal.logo,
            favicon: this.portal.favicon,
            defaultShops: this.portal.defaultShops
          }
        )
        .then(response => {
          this.updateImages = "success";
          // this.portal = response.data || {};
          // console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateImages = "error";
        });
    },
    saveBanners() {
      this.updateBanners = "updating";

      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/gaa/portals/${this.$route.params.portalKey}/banners`,
          {
            banners: this.banners
          }
        )
        .then(response => {
          this.updateBanners = "success";

          // this.portal = response.data || {};
          
          console.log(response.data);
          return response.data;
        })
        .catch(e => {
          console.log(e.stack);
          this.updateBanners = "error";
        });
    },
    removeBanner(index) {
      this.banners.splice(index, 1);
    },
    addBanner() {
      this.banners.push("https://");
    }
  },
  created () {
    this.mode = 'new';
    if (this.$route.params.portalKey) {
      this.getPortalDetail();
      this.mode = 'update';      
    }
      
    // this.getCampaignGroups();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
.k-form-label {
  margin: 5px 0 0 0;
}
.k-form-group {
  margin: 10px 0 10px 0;
}
/* .k-input input { */
/* margin: 10px; */
/* width: 100px; */
/* height: 30px; */
/* } */
</style>